import { render, staticRenderFns } from "./Pig.vue?vue&type=template&id=54208190&scoped=true"
import script from "./Pig.vue?vue&type=script&lang=js"
export * from "./Pig.vue?vue&type=script&lang=js"
import style0 from "./Pig.vue?vue&type=style&index=0&id=54208190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54208190",
  null
  
)

export default component.exports